export default class ContentCards {
  constructor() {
    var isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    if ($(".content-card-info").length) {
      $(".content-card-info").on('click', this.toggleContentCardInfo.bind(this));
    }

    if ($(".content-card-group-preview").length) {
      this.addScrollListeners();
    }
  }

  addScrollListeners() {
    $('.scroll-back').on('click', this.scrollBack.bind(this));
    $('.scroll-forward').on('click', this.scrollForward.bind(this));
  }

  toggleContentCardInfo(e) {
    var infoContainer = $($(e.target).parent().attr('name'));
    if (infoContainer.hasClass('active')) {
      infoContainer.removeClass('active');
    } else {
      infoContainer.addClass('active');
    }
  }

  scrollBack(e) {
    this.container(e).scrollLeft += this.scrollWidth(e) * -1;
  }

  scrollForward(e) {
    this.container(e).scrollLeft += this.scrollWidth(e);
  }

  scrollWidth(e) {
    return this.parentContainer(e).find('.content-card').width() + 20;
  }

  container(e) {
    return this.parentContainer(e).find('.content-card-group-container')[0];
  }

  parentContainer(e) {
    return $(e.target).closest('.content-card-group-preview');
  }

  // isInTopOfView(element) {
  //   var docViewTop = $(window).scrollTop();
  //   var docViewBottom = docViewTop + $(window).height();
  //   var docViewMiddle = ((docViewBottom - docViewTop) / 2) + docViewTop;

  //   var elementTop = $(element).offset().top;
  //   var elementBottom = elementTop + $(element).height();
  //   var elementMiddle = ((elementBottom - elementTop) / 2) + elementTop;

  //   return elementMiddle <= docViewMiddle;
  // }
}
